<template>
  <div class='EnbSlogan'
  :style="{
    backgroundImage: `url(${background})`,
    backgroundSize: `100% 100%`,
    color: Prefes.frentelojaCorFonte.color
  }">
    {{ text }}
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import api from '@/mixins/api'
export default {
  name: 'EnbSlogan',
  mixins: [api],
  data () {
    return {
      background: '',
      text: ''
    }
  },
  computed: {
    ...mapGetters(['Prefes'])
  },
  methods: {
    ...mapActions(['GetFrenteLojaSlogan'])
  },
  created () {
    this.GetFrenteLojaSlogan()
      .then(res => {
        this.text = res.text
        this.background = this.api + res.img
      })
  }
}
</script>

<style scoped>
.EnbSlogan {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 30%;
  color: #000000;
  font-size: 60px;
  font-weight: bold;
  /* efeito neon: currentColor acompanha a cor da fonte escolhida nas preferências;
     a borda um pouco mais clara define o contorno das letras e o brilho fica mais leve */
  -webkit-text-stroke: 0.5px color-mix(in srgb, currentColor 70%, #FFFFFF);
  text-shadow:
    0 0 4px currentColor,
    0 0 12px currentColor,
    0 0 24px currentColor;
}

@media (max-width: 500px) {
  .EnbSlogan {
    width: 90%;
    line-height: 60px;
    height: max-content;
    padding: 5%;
    font-size: 40px;
  }
}
</style>
